/**
 * What an invoice record currently IS, as a document.
 *
 * A record starts life as a proforma with its own reference and becomes a
 * fiscal invoice — with a fiscal number and an issue date — only when it is
 * paid. So the number to show depends on which of the two it is, and showing
 * `invoice_number` alone leaves every unpaid row blank.
 */

export type InvoiceDocumentLike = {
  invoice_number?: string | null;
  proforma_number?: string | null;
  issued_at?: string | null;
  created_at?: string | null;
};

/** True once a fiscal number has been issued. */
export function isFiscalInvoice(invoice: InvoiceDocumentLike): boolean {
  return !!invoice?.invoice_number;
}

/** The reference to display: fiscal number if issued, otherwise the proforma. */
export function invoiceDocumentNumber(invoice: InvoiceDocumentLike): string {
  return invoice?.invoice_number || invoice?.proforma_number || "-";
}

/** "Factură" / "Proformă", for a badge next to the number. */
export function invoiceDocumentLabel(invoice: InvoiceDocumentLike): string {
  return isFiscalInvoice(invoice) ? "Factură" : "Proformă";
}

/** The date that belongs to the document shown — issue date, or drafting date. */
export function invoiceDocumentDate(invoice: InvoiceDocumentLike): string | null {
  return (isFiscalInvoice(invoice) ? invoice?.issued_at : null) || invoice?.created_at || null;
}
